import { usersAPI } from "../api/api";
import ShowNotification from "../components/common/Notification/ShowNotification";

const SET_USERS_DATA = 'SET_USERS_DATA';

export const setUsersData = (payload) => {
    return {
        type: SET_USERS_DATA,
        payload: payload
    }
}

let initialState = {
    users: [],
    totalPages: 0,
    totalElements: 0,
    size: 20,
    currentPage: 0,
}

let usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USERS_DATA:
            return {
                ...state,
                users: action.payload.users || [],
                totalPages: action.payload.totalPages || 0,
                totalElements: action.payload.totalElements || 0,
                size: action.payload.size || 20,
                currentPage: action.payload.currentPage || 0,
            }
        default:
            return state;
    }
}

export const getUsersTh = (page, size) => {
    return async (dispatch) => {
        let response = await usersAPI.getUsers(page, size);
        if (response) {
            dispatch(setUsersData(response));
        } else {
            ShowNotification("Error", "İstifadəçilər yüklənmədi", "danger", 3000);
        }
    }
}

export const addUserTh = (user) => {
    return async (dispatch) => {
        let response = await usersAPI.addUser(user);
        if (response && (response.status === 201 || response.status === 200)) {
            ShowNotification("Uğurlu", "İstifadəçi əlavə olundu", "success");
            dispatch(getUsersTh(0, 20));
        } else {
            let errorMessage = 'Server: ' + (response?.data?.message || 'Unknown error');
            ShowNotification("Error", errorMessage, "danger", 3000);
        }
    }
}

export const updateUserTh = (id, user) => {
    return async (dispatch) => {
        let response = await usersAPI.editUser(id, user);
        if (response && response.status === 200) {
            ShowNotification("Uğurlu", "İstifadəçi yeniləndi", "warning");
            dispatch(getUsersTh(0, 20));
        } else {
            let errorMessage = 'Server: ' + (response?.data?.message || 'Unknown error');
            ShowNotification("Error", errorMessage, "danger", 3000);
        }
    }
}

export const changeUserPasswordTh = (id, password, password_confirmation) => {
    return async (dispatch) => {
        let response = await usersAPI.changeUserPassword(id, password, password_confirmation);
        if (response && response.status === 200) {
            ShowNotification("Uğurlu", "Şifrə dəyişdirildi. İstifadəçi yenidən login etməlidir.", "success", 3000);
        } else {
            let errorMessage = 'Server: ' + (response?.data?.message || 'Unknown error');
            ShowNotification("Error", errorMessage, "danger", 3000);
        }
    }
}

export const deleteUserTh = (id) => {
    return async (dispatch) => {
        let response = await usersAPI.deleteUser(id);
        if (response && response.status === 200) {
            ShowNotification("Uğurlu", "İstifadəçi silindi", "danger");
            dispatch(getUsersTh(0, 20));
        } else {
            let errorMessage = 'Server: ' + (response?.data?.message || 'Unknown error');
            ShowNotification("Error", errorMessage, "danger", 3000);
        }
    }
}

export default usersReducer;
